// extracted by mini-css-extract-plugin
export default {"container":"BundleList_container__43jsQ","circleContainer":"BundleList_circleContainer__IOj7x"};